<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>Documents</v-card-title>

        <v-card-text>
          <div v-for="(document, index) in project.documents" :key="index">
            <v-btn
              text
              class="mb-3 subtitle-1"
              style="text-transform: none;"
              @click="
                downloadDocument({
                  project_id: project.id,
                  file_name: document.name
                })
              "
            >
              {{ document.name }}
            </v-btn>
          </div>

          <div class="pt-3"></div>

          <file-upload-modal
            btnText="upload"
            modalTitle="Upload documents"
            color="primary"
            depressed
          ></file-upload-modal>

          <v-btn
            :to="{ name: 'project', params: { project_id: project.id } }"
            depressed
            color="error"
            class="ml-2"
            >Cancel</v-btn
          >
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FileUploadModal from '@/components/common/FileUploadModal'

export default {
  name: 'ProjectDocuments',
  components: {
    FileUploadModal
  },
  computed: {
    ...mapState('projects', ['project'])
  },
  methods: {
    ...mapActions('projects', ['downloadDocument'])
  }
}
</script>
